import { gql } from '@apollo/client'

export const EVENEMENT_UPDATE_MUTATION = gql`
  mutation EvenementUpdate($id: bigint!, $data: d4_evenementdemande_set_input!) {
    evenement: update_d4_evenementdemande_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      texte
    }
  }
`

export const EVENEMENT_ADD_MUTATION = gql`
  mutation EvenementAdd($data: d4_evenementdemande_insert_input!) {
    evenement: insert_d4_evenementdemande_one(object: $data) {
      id
    }
  }
`
